export default {"src":"/_next/static/media/medicine-bottle-line.8219c828.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};